@for (value of values() | slice: 0 : showCount(); track value; let isLast = $last) {
    <span
        class="hover-address"
        data-bs-toggle="tooltip"
        title="{{ value }}">
        {{ value }}
    </span>
    @if (!isLast) {
        <span>{{ delimiter() }}</span>
    }
}
@if (hasMore()) {
    <span
        class="text-muted"
        [kno2Popover]="popover()"
        popoverTitle=""
        popoverPlacement="right"
        style="white-space: nowrap">
        {{ delimiter() }}[
        <i class="fa fa-plus-circle"></i>
        {{ moreCount() }} more ]
    </span>
}
